(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2722],{

/***/ 25893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);





var makeDayList = function(referenceDate) {
    var dayCount = referenceDate.date(1).daysInMonth();
    /** 1~7 월~일 */ var startWeekDay = referenceDate.day();
    var endWeekDay = referenceDate.date(dayCount).day();
    var firstWeekEmptyArray = Array(startWeekDay).fill(null);
    var lastWeekEmptyArray = Array(6 - endWeekDay).fill(null);
    var dayArray = Array(dayCount).fill(0).map(function(o, index) {
        var day = referenceDate.add(index, "day");
        return day;
    });
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(firstWeekEmptyArray).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(dayArray), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(lastWeekEmptyArray));
};
var withCalendar = function(WrappedComponent) {
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(props, ref) {
        var minDate = props.minDate, maxDate = props.maxDate, value = props.value, data = props.data;
        var min = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
            if (!dayjs__WEBPACK_IMPORTED_MODULE_1___default()(minDate).isValid()) return dayjs__WEBPACK_IMPORTED_MODULE_1___default()();
            return dayjs__WEBPACK_IMPORTED_MODULE_1___default()(minDate);
        }, [
            minDate
        ]);
        var max = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
            if (!dayjs__WEBPACK_IMPORTED_MODULE_1___default()(maxDate).isValid()) return min.add(12, "month");
            return dayjs__WEBPACK_IMPORTED_MODULE_1___default()(maxDate);
        }, [
            maxDate
        ]);
        var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(function() {
            if (value) return dayjs__WEBPACK_IMPORTED_MODULE_1___default()(value);
            return min;
        }), month = _$ref[0], setMonth = _$ref[1];
        var _$ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(function() {
            if (value) return dayjs__WEBPACK_IMPORTED_MODULE_1___default()(value);
            return null;
        }), date = _$ref1[0], setDate = _$ref1[1];
        var dayList = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
            var days = makeDayList(month.date(1));
            return Array.from({
                length: days.length / 7
            }).map(function() {
                return days.splice(0, 7);
            });
        }, [
            month
        ]);
        var rangeMonth = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
            var startMM = dayjs__WEBPACK_IMPORTED_MODULE_1___default()(minDate).set("date", 1);
            var endMM = dayjs__WEBPACK_IMPORTED_MODULE_1___default()(maxDate).set("date", 1);
            var diff = endMM.diff(startMM, "month") + 1;
            return Array.from({
                length: diff
            }).map(function(v, i) {
                return startMM.add(i, "month");
            });
        }, [
            min,
            max
        ]);
        /** 월 변경 */ var monthChange = function(day) {
            var _day = dayjs__WEBPACK_IMPORTED_MODULE_1___default()(day);
            _day.isValid() && setMonth(_day);
            if (props.onMonthChange) props.onMonthChange(_day);
        };
        /** 다음 달 여부 */ var isNext = !month.isSame(max, "month");
        /** 이전 달 여부 */ var isPrevious = !month.isSame(min, "month");
        /** 다음 달 */ var nextMonth = function() {
            return isNext && monthChange(month.add(1, "month").format("YYYYMM"));
        };
        /** 이전 달 */ var prevMonth = function() {
            return isPrevious && monthChange(month.add(-1, "month").format("YYYYMM"));
        };
        var dateChange = function(day, e) {
            setDate(day);
            props.onDateChange(day, e);
        };
        var clearDate = function() {
            setDate(null);
            props.onDateChange(null);
        };
        (0,react__WEBPACK_IMPORTED_MODULE_2__.useImperativeHandle)(ref, function() {
            return {
                min: min,
                max: max,
                month: month,
                date: date,
                isNext: isNext,
                isPrevious: isPrevious,
                dateChange: dateChange,
                clearDate: clearDate,
                monthChange: monthChange,
                nextMonth: nextMonth,
                prevMonth: prevMonth
            };
        });
        var wrapProps = {
            min: min,
            max: max,
            isNext: isNext,
            isPrevious: isPrevious,
            rangeMonth: rangeMonth,
            dayList: dayList,
            month: month,
            date: date,
            dateChange: dateChange,
            clearDate: clearDate,
            monthChange: monthChange,
            nextMonth: nextMonth,
            prevMonth: prevMonth,
            data: data
        };
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, wrapProps))
        });
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (withCalendar);


/***/ }),

/***/ 87061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29815);
/* harmony import */ var _QUERIES_prdt_goods_useGoodsByMenu__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73225);
/* harmony import */ var _STORE_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79390);
/* harmony import */ var _STORE_store_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57467);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var thenby__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80717);
/* harmony import */ var thenby__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(thenby__WEBPACK_IMPORTED_MODULE_4__);







/* filteringProduct */ var filterUtils = function(productList, filterList) {
    if (!productList) return;
    var filteringData = productList;
    var filtering = function() {
        filterList === null || filterList === void 0 ? void 0 : filterList.forEach(function(item) {
            var filterKey = item.key;
            if ([
                "sort"
            ].indexOf(filterKey) > -1) return;
            filteringData = filteringData.reduce(function(acc, product) {
                var filterKeyList = filterList.filter(function(v) {
                    return v.key === filterKey;
                });
                filterKeyList.some(function(filter) {
                    var key = filter.key, value = filter.value;
                    if (key === "minPrice") return Number(product.minPrice) >= Number(value);
                    if (key === "maxPrice") return Number(product.minPrice) <= Number(value);
                    return product[key] && product[key].indexOf(value) > -1;
                // eslint-disable-next-line no-param-reassign
                }) && (acc = acc.concat(product));
                return acc;
            }, []);
        });
    };
    var sorting = function() {
        var getSortOrder = function(dspSid, sortOrderInfo) {
            if (!sortOrderInfo) return 99998;
            // 선택한 지역 (예: AAA0001,AAA0001,.....)
            var dspIdArray = dspSid.split(",");
            // 지역별 정렬 순서 정보 (예: AAA0001^1,AAA0001^2,.....)
            var sortOrderInfoArray = sortOrderInfo.split(",");
            // 선택한 지역들의 정렬 순서정보.
            var filteredSortArray = dspIdArray.reduce(function(acc, cur, idx, arr) {
                sortOrderInfoArray.forEach(function(orderInfo) {
                    var orderInfoArray = orderInfo.split("^");
                    orderInfoArray[0] === cur && acc.push(Number(orderInfoArray[1]));
                });
                return acc;
            }, []);
            // sortOrderInfo가 없다면 맨뒤로 위치함.
            if (!filteredSortArray.length) return 99999;
            // 지역에 해당하는 sort 중 가장 작은 값.
            return Math.min.apply(null, filteredSortArray);
        };
        var sort = (filterList === null || filterList === void 0 ? void 0 : filterList.find(function(v) {
            return v.key === "sort";
        })) || {
            asc: true,
            value: "sortOrder"
        };
        var asc = sort.asc, prop = sort.value;
        var dspSidArray = (filterList === null || filterList === void 0 ? void 0 : filterList.filter(function(v) {
            return v.key === "dspSid";
        })) || [];
        var filterDspSid = dspSidArray.length > 0 ? dspSidArray.reduce(function(acc, item, index, array) {
            return acc.concat(item.value);
        }, []).join(",") : "";
        var copyData = filteringData;
        if (prop === "sortOrder" && filterDspSid) {
            filteringData = copyData.sort((0,thenby__WEBPACK_IMPORTED_MODULE_4__.firstBy)(function(a, b) {
                var aVal = getSortOrder(filterDspSid, a.sortOrderInfo);
                var bVal = getSortOrder(filterDspSid, b.sortOrderInfo);
                // eslint-disable-next-line no-nested-ternary
                return aVal > bVal ? 1 : aVal < bVal ? -1 : 0;
            // eslint-disable-next-line no-nested-ternary
            }).thenBy(function(a, b) {
                return Number(a[prop]) > Number(b[prop]) ? 1 : Number(a[prop]) < Number(b[prop]) ? -1 : 0;
            }));
        } else {
            filteringData = copyData.sort(function(a, b) {
                if (asc) {
                    // eslint-disable-next-line no-nested-ternary
                    return Number(a[prop]) > Number(b[prop]) ? 1 : Number(a[prop]) < Number(b[prop]) ? -1 : 0;
                } else {
                    // eslint-disable-next-line no-nested-ternary
                    return Number(b[prop]) > Number(a[prop]) ? 1 : Number(b[prop]) < Number(a[prop]) ? -1 : 0;
                }
            });
        }
    };
    var getFiltering = function() {
        filtering();
        sorting();
        return filteringData;
    };
    return {
        getFiltering: getFiltering
    };
};
var useFilterStore = function() {
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var dspSid = (ref = router.query) === null || ref === void 0 ? void 0 : ref.dspSid;
    var filterStore = (0,_STORE_index__WEBPACK_IMPORTED_MODULE_1__/* .useAppSelector */ .CG)(function(state) {
        return state.goodsFilterStore;
    });
    var dispatch = (0,_STORE_index__WEBPACK_IMPORTED_MODULE_1__/* .useAppDispatch */ .TL)();
    /** @description store 필터리스트 호출 */ var getFilter = function() {
        return filterStore.goodsFilter && filterStore.goodsFilter[dspSid];
    };
    /** @description store 모든 필터 데이터 변경(분기처리 사용) */ var setFilter = function(arr) {
        var setArray = (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, dspSid, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(arr));
        dispatch((0,_STORE_store_filter__WEBPACK_IMPORTED_MODULE_2__/* .setGoodsFilter */ .Hv)(setArray));
    };
    /** @description store 필터 데이터 추가 */ var addFilter = function() {
        var key = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", value = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", text = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
        var currentFilter = getFilter();
        var filterExists = currentFilter.some(function(item) {
            return item.value === value && item.key === key;
        }); /* 중복제거 */ 
        if (filterExists) return;
        var setArray = (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, dspSid, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(currentFilter).concat([
            {
                key: key,
                value: value,
                text: text
            }
        ]));
        dispatch((0,_STORE_store_filter__WEBPACK_IMPORTED_MODULE_2__/* .setGoodsFilter */ .Hv)(setArray));
    };
    /** @description store 필터 데이터 제거 (value를 입력하지 않으면 모든 key를 제거합니다) */ var removeFilter = function() {
        var key = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", value = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        var currentFilter = getFilter();
        var filterArray = [];
        if (value !== "") {
            filterArray = currentFilter.filter(function(item) {
                return !(item.value === value && item.key === key);
            }); /* 동일한 value 제거 */ 
        } else {
            filterArray = currentFilter.filter(function(item) {
                return item.key !== key;
            }); /* 모든 key 제거 */ 
        }
        var setArray = (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, dspSid, filterArray);
        dispatch((0,_STORE_store_filter__WEBPACK_IMPORTED_MODULE_2__/* .setGoodsFilter */ .Hv)(setArray));
    };
    var getFilteringProduct = function() {
        var ref;
        var productListFetch = (0,_QUERIES_prdt_goods_useGoodsByMenu__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(dspSid);
        var productList = (ref = productListFetch.data) === null || ref === void 0 ? void 0 : ref.body;
        var filterList = getFilter();
        if (productListFetch.isFetching) return [];
        var data = filterUtils(productList, filterList).getFiltering();
        return data;
    };
    return {
        getFilter: getFilter,
        setFilter: setFilter,
        addFilter: addFilter,
        removeFilter: removeFilter,
        getFilteringProduct: getFilteringProduct
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useFilterStore);


/***/ }),

/***/ 6843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21741);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87633);



/** ```
 * 휴일 입력정보 조회
 *   `/esntl/api/contents/holiday/${yyyy}`
 * parameter
 *   `yyyy` 연도
 * ```*/ var key = "useContentsHoliday";
var getPath = function(yyyy) {
    if (!yyyy) return null;
    return "/esntl/api/contents/holiday/".concat(yyyy);
};
/** ```
 * 휴일 입력정보 조회
 *   `/esntl/api/contents/holiday/${yyyy}`
 * parameter
 *   `yyyy` 연도
 * ```*/ var useContentsHoliday = function(yyyy, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(yyyy)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(yyyy)
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useContentsHoliday);



/***/ }),

/***/ 67964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPath */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21741);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 상품의 월별 행사 가져오기
 *   `/prdt/api/event/by-goods/${goodsCd}/${dspSid}/${yyyymm}`
 * parameter
 *   `goodsCd` 상품코드
 *   `dspSid` 지역코드
 *   `yyyymm` 년월
 * ```*/ var key = "useEventByGoodsMonth";
var getPath = function(dspSid, goodsCd, yyyymm) {
    if (!dspSid || !goodsCd || !yyyymm) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PRODUCT_API_BASEPATH */ .Z.ENV_PRODUCT_API_BASEPATH, "/api/event/by-goods/").concat(goodsCd, "/").concat(dspSid, "/").concat(yyyymm);
};
/** ```
 * 상품의 월별 행사 가져오기
 *   `/prdt/api/event/by-goods/${goodsCd}/${dspSid}/${yyyymm}`
 * parameter
 *   `dspSid` 지역코드
 *   `goodsCd` 상품코드
 *   `yyyymm` 년월
 * ```*/ var useEventByGoodsMonth = function(dspSid, goodsCd, yyyymm, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(dspSid, goodsCd, yyyymm)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(dspSid, goodsCd, yyyymm)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 1000 * 60
    }, options));
};
/* harmony default export */ __webpack_exports__["Z"] = (useEventByGoodsMonth);



/***/ }),

/***/ 73225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPath */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21741);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 상품 리스트 조회
 *   `/api/goods/by-menu/${dspSid}`
 * parameter
 *   `dspSid` 지역코드
 * ```*/ var key = "useGoodsByMenu";
var getPath = function(dspSid) {
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_PRODUCT_API_BASEPATH */ .Z.ENV_PRODUCT_API_BASEPATH, "/api/goods/by-menu/").concat(dspSid);
};
/** ```
 * 상품 리스트 조회
 *   `/api/goods/by-menu/${dspSid}`
 * parameter
 *   `dspSid` 지역코드
 * ```*/ var useGoodsByMenu = function(dspSid, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(dspSid)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(dspSid)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: Infinity,
        gcTime: Infinity
    }, options));
};
/* harmony default export */ __webpack_exports__["Z"] = (useGoodsByMenu);



/***/ }),

/***/ 3081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, key, goodsDetailAsync, goodsDetailSSR */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _COMPONENTS_common_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23234);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21741);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87633);





/** ```
 * 상품 정보 조회
 *   `/prdt/api/goods/join-event/{goodsCd}`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var key = "useGoodsDetail";
var getPath = function(goodsCd) {
    if (!goodsCd) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PRODUCT_API_BASEPATH */ .Z.ENV_PRODUCT_API_BASEPATH, "/api/goods/join-event/").concat(goodsCd);
};
/** ```
 * 상품 정보 조회
 *   `/prdt/api/goods/join-event/{goodsCd}`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var goodsDetailAsync = function(goodsCd) {
    return useConfigureAxios(getPath(goodsCd), {
        method: "GET"
    });
};
/** ```
 * 상품 정보 조회
 *   `/prdt/api/goods/join-event/{goodsCd}`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var goodsDetailSSR = function(goodsCd) {
    var removepath = publicRuntimeConfig.RUNTIME_ENV === "local" ? "" : publicRuntimeConfig.ENV_PRODUCT_API_BASEPATH;
    return useConfigureAxios("".concat(publicRuntimeConfig.ENV_PRODUCT_API_URL).concat(getPath(goodsCd).replace(removepath, "")), {
        method: "GET"
    });
};
/** ```
 * 상품 정보 조회
 *   `/prdt/api/goods/join-event/{goodsCd}`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var useGoodsDetail = function(goodsCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(goodsCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                url: getPath(goodsCd)
            }).then(function(r) {
                return r.data;
            });
        },
        // staleTime: 1000 * 30 * 60,
        placeholderData: {
            body: _COMPONENTS_common_constants__WEBPACK_IMPORTED_MODULE_0__/* .GOODS_DETAIL */ .Ev
        }
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useGoodsDetail);



/***/ }),

/***/ 51820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "iS": function() { return /* binding */ goodsAvailEventAsync; }
/* harmony export */ });
/* unused harmony exports getPath, key, goodsAvailEventSSR */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20414);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21741);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87633);






var key = "useGoodsAvailEvent";
/** ```
 *  해당 상품의 가장 빠른 행사 , 일자 , 전시된 월
 *   `/prdt/api/goods/${goodsCd}/available-date/{searchType}`
 * parameter
 *   `goodsCd` 상품코드
 *   `searchType` 검색타입 amt | day
 * ```*/ var getPath = function(goodsCd, searchType) {
    if (!goodsCd) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PRODUCT_API_BASEPATH */ .Z.ENV_PRODUCT_API_BASEPATH, "/api/goods/").concat(goodsCd, "/available-date/").concat(searchType);
};
/** ```
 *  해당 상품의 가장 빠른 행사 , 일자 , 전시된 월
 *   `/prdt/api/goods/${goodsCd}/available-date/{searchType}`
 * parameter
 *   `goodsCd` 상품코드
 *   `searchType` 검색타입 amt | day
 * ```*/ var goodsAvailEventAsync = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(goodsCd) {
        var searchType, result, _tmp;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    searchType = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "day";
                    _tmp = {};
                    return [
                        4,
                        (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(getPath(goodsCd, searchType), (_tmp.method = "GET", _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return function goodsAvailEventAsync(goodsCd) {
        return _ref.apply(this, arguments);
    };
}();
/** ```
 *  해당 상품의 가장 빠른 행사 , 일자 , 전시된 월
 *   `/prdt/api/goods/${goodsCd}/available-date/{searchType}`
 * parameter
 *   `goodsCd` 상품코드
 *   `searchType` 검색타입 amt | day
 * ```*/ var goodsAvailEventSSR = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(goodsCd) {
        var searchType, result, _tmp;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    searchType = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "day";
                    _tmp = {};
                    return [
                        4,
                        (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PRODUCT_API_URL */ .Z.ENV_PRODUCT_API_URL + getPath(goodsCd, searchType), (_tmp.method = "GET", _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return function goodsAvailEventSSR(goodsCd) {
        return _ref.apply(this, arguments);
    };
}();
/** ```
 *  해당 상품의 가장 빠른 행사 , 일자 , 전시된 월
 *   `/prdt/api/goods/${goodsCd}/available-date/{searchType}`
 * parameter
 *   `goodsCd` 상품코드
 *   `searchType` 검색타입 amt | day
 * ```*/ var useGoodsAvailEvent = function(goodsCd) {
    var searchType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "day", options = arguments.length > 2 ? arguments[2] : void 0;
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(goodsCd, searchType)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(goodsCd, searchType)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 1000 * 30 * 60
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useGoodsAvailEvent);



/***/ }),

/***/ 29306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21741);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 상품에 설정된 옵션
 *   `/prdt/api/goods/${goodsCd}/option`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var key = "useGoodsOption";
var getPath = function(goodsCd) {
    if (!goodsCd) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PRODUCT_API_BASEPATH */ .Z.ENV_PRODUCT_API_BASEPATH, "/api/goods/").concat(goodsCd, "/option");
};
/** ```
 * 상품에 설정된 옵션
 *   `/prdt/api/goods/${goodsCd}/option`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var useGoodsOption = function(goodsCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(goodsCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(goodsCd)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 1000 * 30 * 60
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useGoodsOption);



/***/ }),

/***/ 80717:
/***/ (function(module) {

/***
   Copyright 2013 Teun Duynstee

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/
module.exports = (function() {

    function identity(v){return v;}

    function ignoreCase(v){return typeof(v)==="string" ? v.toLowerCase() : v;}

    function makeCompareFunction(f, opt){
        opt = typeof(opt)==="object" ? opt : {direction:opt};
        
        if(typeof(f)!="function"){
            var prop = f;
            // make unary function
            f = function(v1){return !!v1[prop] ? v1[prop] : "";}
        }
        if(f.length === 1) {
            // f is a unary function mapping a single item to its sort score
            var uf = f;
            var preprocess = opt.ignoreCase?ignoreCase:identity;
            var cmp = opt.cmp || function(v1,v2) {return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;}
            f = function(v1,v2) {return cmp(preprocess(uf(v1)), preprocess(uf(v2)));}
        }
        const descTokens = {"-1":'', desc:''};
        if(opt.direction in descTokens) return function(v1,v2){return -f(v1,v2)};
        return f;
    }

    /* adds a secondary compare function to the target function (`this` context)
       which is applied in case the first one returns 0 (equal)
       returns a new compare function, which has a `thenBy` method as well */
    function tb(func, opt) {
        /* should get value false for the first call. This can be done by calling the 
        exported function, or the firstBy property on it (for es6 module compatibility)
        */
        var x = (typeof(this) == "function" && !this.firstBy) ? this : false;
        var y = makeCompareFunction(func, opt);
        var f = x ? function(a, b) {
                        return x(a,b) || y(a,b);
                    }
                  : y;
        f.thenBy = tb;
        return f;
    }
    tb.firstBy = tb;
    return tb;
})();


/***/ })

}]);